import { render, staticRenderFns } from "./KintaiInputPage.vue?vue&type=template&id=2b9192ef&scoped=true&"
import script from "./KintaiInputPage.vue?vue&type=script&lang=ts&"
export * from "./KintaiInputPage.vue?vue&type=script&lang=ts&"
import style0 from "./KintaiInputPage.vue?vue&type=style&index=0&id=2b9192ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9192ef",
  null
  
)

export default component.exports